/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CatalogPreviewResponseDto } from '../models/catalog-preview-response-dto';
import { CatalogUploadUrlResponseDto } from '../models/catalog-upload-url-response-dto';
import { customCssControllerCreate } from '../fn/stores/custom-css-controller-create';
import { CustomCssControllerCreate$Params } from '../fn/stores/custom-css-controller-create';
import { customCssControllerFindLatestByProduct } from '../fn/stores/custom-css-controller-find-latest-by-product';
import { CustomCssControllerFindLatestByProduct$Params } from '../fn/stores/custom-css-controller-find-latest-by-product';
import { CustomCssPresetDto } from '../models/custom-css-preset-dto';
import { PaginatedStoresResponseDto } from '../models/paginated-stores-response-dto';
import { revenueCalculatorConfigControllerCreate } from '../fn/stores/revenue-calculator-config-controller-create';
import { RevenueCalculatorConfigControllerCreate$Params } from '../fn/stores/revenue-calculator-config-controller-create';
import { revenueCalculatorConfigControllerFindByStoreId } from '../fn/stores/revenue-calculator-config-controller-find-by-store-id';
import { RevenueCalculatorConfigControllerFindByStoreId$Params } from '../fn/stores/revenue-calculator-config-controller-find-by-store-id';
import { revenueCalculatorConfigControllerUpdate } from '../fn/stores/revenue-calculator-config-controller-update';
import { RevenueCalculatorConfigControllerUpdate$Params } from '../fn/stores/revenue-calculator-config-controller-update';
import { RevenueCalculatorConfigDto } from '../models/revenue-calculator-config-dto';
import { storeCatalogsControllerCreateUploadUrl } from '../fn/stores/store-catalogs-controller-create-upload-url';
import { StoreCatalogsControllerCreateUploadUrl$Params } from '../fn/stores/store-catalogs-controller-create-upload-url';
import { storeCatalogsControllerPreviewCatalog } from '../fn/stores/store-catalogs-controller-preview-catalog';
import { StoreCatalogsControllerPreviewCatalog$Params } from '../fn/stores/store-catalogs-controller-preview-catalog';
import { storeControllerCreate } from '../fn/stores/store-controller-create';
import { StoreControllerCreate$Params } from '../fn/stores/store-controller-create';
import { storeControllerDelete } from '../fn/stores/store-controller-delete';
import { StoreControllerDelete$Params } from '../fn/stores/store-controller-delete';
import { storeControllerFindById } from '../fn/stores/store-controller-find-by-id';
import { StoreControllerFindById$Params } from '../fn/stores/store-controller-find-by-id';
import { storeControllerFindMany } from '../fn/stores/store-controller-find-many';
import { StoreControllerFindMany$Params } from '../fn/stores/store-controller-find-many';
import { storeControllerUpdate } from '../fn/stores/store-controller-update';
import { StoreControllerUpdate$Params } from '../fn/stores/store-controller-update';
import { StoreDto } from '../models/store-dto';

@Injectable({ providedIn: 'root' })
export class PlatformStoresService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `storeControllerFindMany()` */
  static readonly StoreControllerFindManyPath = '/api/v1/stores';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeControllerFindMany()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeControllerFindMany$Response(
    params: StoreControllerFindMany$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<PaginatedStoresResponseDto>> {
    const obs = storeControllerFindMany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeControllerFindMany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeControllerFindMany(
    params: StoreControllerFindMany$Params,
    context?: HttpContext
  ): Observable<PaginatedStoresResponseDto> {
    const resp = this.storeControllerFindMany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PaginatedStoresResponseDto>): PaginatedStoresResponseDto => r.body)
    );
  }

  /** Path part for operation `storeControllerCreate()` */
  static readonly StoreControllerCreatePath = '/api/v1/stores';

  /**
   * Create store.
   *
   * Create a new store. A Firebase JWT is always required (the JWT identifies the creator). SuperAdmin tokens may call this endpoint directly; non-SuperAdmin tokens must additionally include the platform service api-key header (used by 3rd-party install flows such as the Shopify app, where the api-key authorizes the role bypass and the JWT identifies the user being onboarded). When `assignCreatorAsAdmin=true`, the user identified by the JWT is auto-assigned as an admin of the new store.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storeControllerCreate$Response(
    params: StoreControllerCreate$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<StoreDto>> {
    const obs = storeControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create store.
   *
   * Create a new store. A Firebase JWT is always required (the JWT identifies the creator). SuperAdmin tokens may call this endpoint directly; non-SuperAdmin tokens must additionally include the platform service api-key header (used by 3rd-party install flows such as the Shopify app, where the api-key authorizes the role bypass and the JWT identifies the user being onboarded). When `assignCreatorAsAdmin=true`, the user identified by the JWT is auto-assigned as an admin of the new store.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storeControllerCreate(
    params: StoreControllerCreate$Params,
    context?: HttpContext
  ): Observable<StoreDto> {
    const resp = this.storeControllerCreate$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<StoreDto>): StoreDto => r.body));
  }

  /** Path part for operation `storeControllerFindById()` */
  static readonly StoreControllerFindByIdPath = '/api/v1/stores/{storeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeControllerFindById$Response(
    params: StoreControllerFindById$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<StoreDto>> {
    const obs = storeControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeControllerFindById(
    params: StoreControllerFindById$Params,
    context?: HttpContext
  ): Observable<StoreDto> {
    const resp = this.storeControllerFindById$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<StoreDto>): StoreDto => r.body));
  }

  /** Path part for operation `storeControllerDelete()` */
  static readonly StoreControllerDeletePath = '/api/v1/stores/{storeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeControllerDelete$Response(
    params: StoreControllerDelete$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<StoreDto>> {
    const obs = storeControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeControllerDelete(
    params: StoreControllerDelete$Params,
    context?: HttpContext
  ): Observable<StoreDto> {
    const resp = this.storeControllerDelete$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<StoreDto>): StoreDto => r.body));
  }

  /** Path part for operation `storeControllerUpdate()` */
  static readonly StoreControllerUpdatePath = '/api/v1/stores/{storeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storeControllerUpdate$Response(
    params: StoreControllerUpdate$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<StoreDto>> {
    const obs = storeControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storeControllerUpdate(
    params: StoreControllerUpdate$Params,
    context?: HttpContext
  ): Observable<StoreDto> {
    const resp = this.storeControllerUpdate$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<StoreDto>): StoreDto => r.body));
  }

  /** Path part for operation `storeCatalogsControllerCreateUploadUrl()` */
  static readonly StoreCatalogsControllerCreateUploadUrlPath =
    '/api/v1/stores/{storeId}/catalogs/upload-url';

  /**
   * Create a signed URL for uploading a GenericCsvCustom catalog file.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeCatalogsControllerCreateUploadUrl()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storeCatalogsControllerCreateUploadUrl$Response(
    params: StoreCatalogsControllerCreateUploadUrl$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<CatalogUploadUrlResponseDto>> {
    const obs = storeCatalogsControllerCreateUploadUrl(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a signed URL for uploading a GenericCsvCustom catalog file.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeCatalogsControllerCreateUploadUrl$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storeCatalogsControllerCreateUploadUrl(
    params: StoreCatalogsControllerCreateUploadUrl$Params,
    context?: HttpContext
  ): Observable<CatalogUploadUrlResponseDto> {
    const resp = this.storeCatalogsControllerCreateUploadUrl$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<CatalogUploadUrlResponseDto>): CatalogUploadUrlResponseDto => r.body
      )
    );
  }

  /** Path part for operation `storeCatalogsControllerPreviewCatalog()` */
  static readonly StoreCatalogsControllerPreviewCatalogPath =
    '/api/v1/stores/{storeId}/catalogs/preview';

  /**
   * Preview headers from a private-bucket GenericCsvCustom catalog.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeCatalogsControllerPreviewCatalog()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeCatalogsControllerPreviewCatalog$Response(
    params: StoreCatalogsControllerPreviewCatalog$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<CatalogPreviewResponseDto>> {
    const obs = storeCatalogsControllerPreviewCatalog(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Preview headers from a private-bucket GenericCsvCustom catalog.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeCatalogsControllerPreviewCatalog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeCatalogsControllerPreviewCatalog(
    params: StoreCatalogsControllerPreviewCatalog$Params,
    context?: HttpContext
  ): Observable<CatalogPreviewResponseDto> {
    const resp = this.storeCatalogsControllerPreviewCatalog$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CatalogPreviewResponseDto>): CatalogPreviewResponseDto => r.body)
    );
  }

  /** Path part for operation `customCssControllerCreate()` */
  static readonly CustomCssControllerCreatePath = '/api/v1/stores/{storeId}/custom-css';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customCssControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customCssControllerCreate$Response(
    params: CustomCssControllerCreate$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<CustomCssPresetDto>>> {
    const obs = customCssControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customCssControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customCssControllerCreate(
    params: CustomCssControllerCreate$Params,
    context?: HttpContext
  ): Observable<Array<CustomCssPresetDto>> {
    const resp = this.customCssControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<CustomCssPresetDto>>): Array<CustomCssPresetDto> => r.body)
    );
  }

  /** Path part for operation `customCssControllerFindLatestByProduct()` */
  static readonly CustomCssControllerFindLatestByProductPath =
    '/api/v1/stores/{storeId}/custom-css/{product}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customCssControllerFindLatestByProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  customCssControllerFindLatestByProduct$Response(
    params: CustomCssControllerFindLatestByProduct$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<CustomCssPresetDto>> {
    const obs = customCssControllerFindLatestByProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customCssControllerFindLatestByProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customCssControllerFindLatestByProduct(
    params: CustomCssControllerFindLatestByProduct$Params,
    context?: HttpContext
  ): Observable<CustomCssPresetDto> {
    const resp = this.customCssControllerFindLatestByProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CustomCssPresetDto>): CustomCssPresetDto => r.body)
    );
  }

  /** Path part for operation `revenueCalculatorConfigControllerFindByStoreId()` */
  static readonly RevenueCalculatorConfigControllerFindByStoreIdPath =
    '/api/v1/stores/{storeId}/revenue-calculator-config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revenueCalculatorConfigControllerFindByStoreId()` instead.
   *
   * This method doesn't expect any request body.
   */
  revenueCalculatorConfigControllerFindByStoreId$Response(
    params: RevenueCalculatorConfigControllerFindByStoreId$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<RevenueCalculatorConfigDto>> {
    const obs = revenueCalculatorConfigControllerFindByStoreId(
      this.http,
      this.rootUrl,
      params,
      context
    );
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `revenueCalculatorConfigControllerFindByStoreId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  revenueCalculatorConfigControllerFindByStoreId(
    params: RevenueCalculatorConfigControllerFindByStoreId$Params,
    context?: HttpContext
  ): Observable<RevenueCalculatorConfigDto> {
    const resp = this.revenueCalculatorConfigControllerFindByStoreId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RevenueCalculatorConfigDto>): RevenueCalculatorConfigDto => r.body)
    );
  }

  /** Path part for operation `revenueCalculatorConfigControllerCreate()` */
  static readonly RevenueCalculatorConfigControllerCreatePath =
    '/api/v1/stores/{storeId}/revenue-calculator-config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revenueCalculatorConfigControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  revenueCalculatorConfigControllerCreate$Response(
    params: RevenueCalculatorConfigControllerCreate$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<RevenueCalculatorConfigDto>> {
    const obs = revenueCalculatorConfigControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `revenueCalculatorConfigControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  revenueCalculatorConfigControllerCreate(
    params: RevenueCalculatorConfigControllerCreate$Params,
    context?: HttpContext
  ): Observable<RevenueCalculatorConfigDto> {
    const resp = this.revenueCalculatorConfigControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RevenueCalculatorConfigDto>): RevenueCalculatorConfigDto => r.body)
    );
  }

  /** Path part for operation `revenueCalculatorConfigControllerUpdate()` */
  static readonly RevenueCalculatorConfigControllerUpdatePath =
    '/api/v1/stores/{storeId}/revenue-calculator-config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revenueCalculatorConfigControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  revenueCalculatorConfigControllerUpdate$Response(
    params: RevenueCalculatorConfigControllerUpdate$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<RevenueCalculatorConfigDto>> {
    const obs = revenueCalculatorConfigControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `revenueCalculatorConfigControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  revenueCalculatorConfigControllerUpdate(
    params: RevenueCalculatorConfigControllerUpdate$Params,
    context?: HttpContext
  ): Observable<RevenueCalculatorConfigDto> {
    const resp = this.revenueCalculatorConfigControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RevenueCalculatorConfigDto>): RevenueCalculatorConfigDto => r.body)
    );
  }
}
